import { ContactsPage, MetaData } from '@/components'

export default function NextContactsPage(props) {
  const { meta } = props;
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || "Контакты медцентра Sante";
  const description = descFromProps || "Медицинский центр «Sante» в Минске: адрес, контактный телефон, как добраться"

  return (
    <>
      <MetaData title={title} description={description}  />
      <ContactsPage {...props} />
    </>
  )
}

NextContactsPage.getInitialProps = async ({api}) => {
  const response = await api.contacts()
  return { ...response, pageType:'contacts' }
}
